import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=d14f07fc&scoped=true&"
import script from "./Simple.vue?vue&type=script&lang=ts&"
export * from "./Simple.vue?vue&type=script&lang=ts&"
import style0 from "./Simple.vue?vue&type=style&index=0&id=d14f07fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d14f07fc",
  null
  
)

export default component.exports